import "./Awards.css";

const Awards = () => {
  return (
    <div className="award_section">
      <div className="hero_img award_hero_img">
      <img src="/assets/awards_banner.jpg" alt="" />

      <div className="hero_title">Awards and Recognitions</div>

      </div>
      <div className="container2">
        <div className="portp_div2 container">
          <div className="portp_div21 aw_div ">
            <h2>Great Place to Work</h2>
            <p>
              Our culture at Crest is rooted in the pillars of Care, Connect,
              and Collaborate and is powered by our people. In the prestigious
              list of GPTW, Crest Digitel has been recognized as a Great Place
              to Work® (2023) for two consecutive years now! The Great Place to
              Work® Institute relies heavily on its rigorous methodology, which
              is recognized by the government as the key to receiving the award.
              Since it is objective and transparent, it is regarded as one of
              the gold standards when it comes to defining a great workplace
              across a wide range of industries, academia, government
              departments etc. This recognition truly serves as validation of
              the productive environment we have built, which encourages
              employees to feel valued, take initiative, and prosper.
            </p>
          </div>
          <div className="portp_div31">
            <img src="/assets/awards/awardimg2.jpg" alt="" />
          </div>
        </div>

        <div className="aw_flex portp_div2 container">
          <div className="portp_div31">
            <img src="/assets/awards/awardimg3.jpg" alt="" />
          </div>
          <div className="portp_div21 aw_div ">
            <h2>Top HR Innovator Award</h2>
            <p>
              Dolly Grover, the CHRO of Crest Digitel, was recognized as the top
              HR innovator at the Asia HRM Congress Awards 2022 for implementing
              new ideas, methods and technologies into practice to better meet
              the organization’s and its workforce’s ever-changing needs over
              the past three decades.
            </p>
          </div>
        </div>

        <div className="portp_div2 container aw_flex">
          <div className="portp_div21  aw_div">
            <h2>
              India's Best Leaders <br /> in Times of Crisis 2021
            </h2>
            <p>
              Sanjay Nandrajog, the CEO of Crest Digitel, was named one of
              India’s Best Leaders in Times of Crisis 2021 in the mid-sized
              category by Great Place to Work® India. In order to obtain insight
              into the varied ways in which organizations dealt with the VUCA
              environment that the pandemic had exacerbated, Great Place to
              Work® India conducted a special study. 75 leaders were recognized
              for their exemplary leadership during the very challenging year,
              out of approximately 700 companies studied, with 25 leaders
              identified in the mid-sized category.
            </p>
          </div>
          <div className="portp_div31">
            <img src="/assets/awards/awardimg4.jpg" alt="" />
          </div>
        </div>

        <div className="portp_div2 container">
          <div className="portp_div31">
            <img src="/assets/awards/awardimg5.jpg" alt="" />
          </div>
          <div className="portp_div21 aw_div  ">
            <h2>Rotary CSR Recognition </h2>
            <p>
              Crest Digitel received the Rotary CSR award for its exceptional
              corporate social responsibility in 2021. This honor is a testament
              to our commitment to giving back to society through several
              initiatives that focus on healthcare, education and livelihood.
            </p>
          </div>
        </div>
        <div className="portp_div2 container">
          <div className="portp_div21  aw_div">
            <h2>
              Crest Digitel Recognized for <br className="award_br" /> outstanding services from{" "}
              <br  className="award_br" /> Himachal Pradesh University
            </h2>
            <p>
              As part of the 50th foundation day celebrations of Himachal
              Pradesh University, Crest Digitel was recognized for establishing
              seamless connectivity that enabled the university’s educational
              facilities to operate. This ceremony was formally inaugurated by
              Chief Minister Jairam Thakur. Vineet Sirpaul, Chief Sales and
              Acquisition Officer and Vinay Kumar, AVP-Institutional
              Acquisition, were honoured with the award.
            </p>
          </div>
          <div className="portp_div31">
            <img src="/assets/awards/awardimg6.jpg" alt="" />
          </div>
        </div>
        <div className="portp_div2 container">
          <div className="portp_div31">
            <img src="/assets/awards/awardimg7.jpg" alt="" />
          </div>
          <div className="portp_div21 aw_div ">
            <h2>Small Cells Milestone</h2>
            <p>
              Mumbai Circle has been recognized for having contributed the
              highest number of small cells to help Airtel Mumbai achieve the
              500 Small Cells milestone.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Awards;
